import {FRBase} from "#Formulas/FormulaCore/FRBase";
import {FRFactory} from "#Formulas/FormulaCore/FRFactory";
import {FRVariable} from "#Formulas/FormulaCore/Elements/FRVariable";
import {FRMembE} from "#Formulas/FormulaCore/Elements/FRMembE";


export class FRAssigmentExpression extends FRBase{
    private Asignee:FRBase;
    private Value:FRBase;
    constructor(Options: any, Parent: FRBase) {
        super(Options, Parent);
        this.Asignee=FRFactory.GetFRElement(this.Options.As,this);
        this.Value=FRFactory.GetFRElement(this.Options.D,this);
    }

    Parse(): any {

        return this.MaybeExecutePromise(this.Value.Parse(),value=>{
            if(this.Asignee.Type=='VAR')
                (this.Asignee as any).Assign(value);
            else
            {
                return this.MaybeExecutePromise((this.Asignee as FRMembE).Assign(value),()=>{});
            }
        });

    }

}

FRFactory.AddField('AE',FRAssigmentExpression);